import React, { useState, useEffect } from 'react';
import "./sidebarLeft.scss";
import { MdEmail } from "react-icons/md";
import { AiTwotonePhone } from "react-icons/ai";
import { BsMoonStarsFill } from "react-icons/bs"
import { MdLightMode } from "react-icons/md";
import { useTranslation } from 'react-i18next';


function SidebarLeft() {
  const { t } = useTranslation();
  const [darkMode, setDarkMode] = useState(false);

  // Thêm logic này để thực sự đổi màu trang web
  useEffect(() => {
    document.body.classList.toggle('dark-mode', darkMode);
  }, [darkMode]);


  return (
    <div className='contact_container'>
      <ul className='contact_container-list'>
        <li>
          <a href="mailto:Info@hsv.com.vn">
            <MdEmail />
            <p>{t('common.email')}</p>
          </a>
        </li>
        <li>
          <a href="tel:+84917632112">
            <AiTwotonePhone />
            <p>{t('common.call_now')}</p>
          </a>
        </li>
        <li onClick={() => setDarkMode(!darkMode)}>
          {
            darkMode
              ? <a href="#" style={{ pointerEvents: "none" }}>
                <BsMoonStarsFill />
                <p>{t('common.dark')}</p>
              </a>
              : <a href="#">
                <MdLightMode />
                <p>{t('common.light')}</p>
              </a>
          }
        </li>
      </ul>
    </div>
  );
}

export default SidebarLeft;